import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Input, InputAddon, InputGroup, Select } from '@chakra-ui/react';
import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { normalizeString } from 'utils/functions/formatString';
import { GroupInputWrapper } from '../../styles/styles';
import countries from 'services/mocks/countries.json';
import { useReferralProvider } from 'providers/referralsProvider/ReferralProvider';

interface InputPhoneProps {
  handleFieldValidation: (e: any) => void;
  handleNumberFieldChange: (e: any) => void;
  maxLengthcodArea: number;
  maxLengthNumber: number;
  values: {
    codArea: number | string,
    phone: number | string,
    nacionality: string,
  },
  error,
  errorMessage
}

export interface ICountries {
  id: number;
  nombre: string;
  estado: string;
  fechaEstado: string;
  codDN: string;
  comp: string;
  estadoAut: string;
  fechaAut: string;
  tipoDocId: number;
  paisDisplay: string;
  paisCodTel: string;
}

const PhoneNumber: React.FC<InputPhoneProps> = ({ values: { codArea, phone, nacionality }, handleFieldValidation, handleNumberFieldChange, error, errorMessage, maxLengthcodArea, maxLengthNumber }) => {

  const { subscriberData } = useReferralProvider() || {};

  const [countryFlag, setCountryFlag] = useState('ar')

  const handleSetCountryFlag = nombre => setCountryFlag(nombre)

  const handleChange = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
    if (e) {
      const countryString = e.target.value.toLowerCase();
      handleSetCountryFlag(countryString);
      handleNumberFieldChange(e);
      const selectedPhoneNumber: ICountries = countries.find(country => normalizeString(country.codDN) === countryString);
      const nacionality = {
        target: {
          name: 'nacionality',
          value: normalizeString(selectedPhoneNumber.codDN)
        }
      };
      const codPais = {
        target: {
          name: 'codPais',
          value: selectedPhoneNumber.paisCodTel
        }
      };
      const codArea = {
        target: {
          name: 'codArea',
          value: ''
        }
      };

      const phone = {
        target: {
          name: 'phone',
          value: ''
        }
      };
      handleNumberFieldChange(codPais)
      handleNumberFieldChange(nacionality)
      handleNumberFieldChange(codArea)
      handleNumberFieldChange(phone)
      handleFieldValidation(e)
    }
  }, [nacionality]);

  useEffect(() => {
    if (subscriberData?.nacionality) {
      handleSetCountryFlag(subscriberData.nacionality);
    }
  }, [subscriberData])

  return (
    <FormControl isInvalid={error}>
      <FormLabel textStyle='labelMd' display='contents' color='#2F3034'>
        Teléfono
      </FormLabel>
      <GroupInputWrapper>
        <InputGroup>
          <InputAddon
            className='form-input'
            bg='white'
            borderRadius='var(--chakra-radii-md) !important'
            w='28%'
            pl='var(--chakra-space-2)'
            pr={0}
          >
            <span className={`flag flag-${countryFlag}`} />
            <Select
              value={nacionality}
              name='codPais'
              onChange={e => handleChange(e)}
              onBlur={handleFieldValidation}
              data-testid='countryPhoneCode-input'
              className='phoneNumber'
              bg='white'
            >
              {countries.map(({ codDN, paisCodTel }) => paisCodTel && (
                <option value={normalizeString(codDN)} key={codDN}>
                  +{paisCodTel}
                </option>
              ))}
            </Select>
          </InputAddon>
          <Input
            value={String(codArea)}
            name='codArea'
            w='46%'
            onChange={handleNumberFieldChange}
            onBlur={handleFieldValidation}
            maxLength={maxLengthcodArea}
            className='form-input'
            data-testid='codArea-input'
            bg='white'
            type='text'
            placeholder='Código'
            mx={2}
          />
          <Input
            value={String(phone)}
            name='phone'
            data-testid='phone-input'
            onChange={handleNumberFieldChange}
            onBlur={handleFieldValidation}
            maxLength={maxLengthNumber}
            minLength={4}
            className='form-input'
            bg='white'
            type='text'
            placeholder='Número'
          />
        </InputGroup>
        {error ? <FormErrorMessage>{errorMessage}</FormErrorMessage> : <FormHelperText>{errorMessage}</FormHelperText>}
      </GroupInputWrapper>
    </FormControl>
  );
};

export default PhoneNumber;
